import LookupCustomersRequestModelBase from '../_generated/modelBases/lookup-customers-request-model-base';

export default class LookupCustomersRequestModel extends LookupCustomersRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
